<template>
	<div>
		<v-data-table
			v-if="hasItens"
			v-model="itensAdesaoSelecionados"
			:headers="colunas"
			:items="itens"
			:show-select="podeExibirCheckbox()"
			item-key="idItemAdesao"
			hide-default-footer
			:server-items-length="totalItens"
			:options="paginacao"
			class="arp-listview mt-5 row-pointer"
		>
			<template #[`header.data-table-select`]="{}">
				<v-simple-checkbox
					id="iDCheckboxItemAdesao"
					:value="itensAdesaoSelecionados.length === totalItens"
					:indeterminate="itensAdesaoSelecionados.length > 0 && itensAdesaoSelecionados.length < totalItens"
					color="primary"
					@input="onSelectAll($event)"
				></v-simple-checkbox>
			</template>
			<template #item.icone="{ item }">
				<icone-estornado @acao="abrirModalEstorno(item, false)" v-if="itemEstornouTudo(item)"></icone-estornado>
				<icone-estornado-parcialmente
					@acao="abrirModalEstorno(item, false)"
					v-if="itemEstornouParcialmente(item)"
				></icone-estornado-parcialmente>
			</template>
			<template #item.tipo="{ item }">
				<texto-tooltip
					:class="itemEstornouTudo(item) ? 'text-decoration-line-through' : ''"
					:texto="item.grupo"
					:tamanho-maximo="textoTamanhoMaximo.tipo"
				></texto-tooltip>
			</template>
			<template #item.seq="{ item }">
				<span :class="itemEstornouTudo(item) ? 'text-decoration-line-through' : ''">
					{{ item.sequencia }}
				</span>
			</template>
			<template #item.descricao="{ item }">
				<texto-tooltip
					:class="itemEstornouTudo(item) ? 'text-decoration-line-through' : ''"
					:texto="item.descricao"
					:tamanho-maximo="textoTamanhoMaximo.descricao"
				></texto-tooltip>
			</template>
			<template #item.unidadeDespesa="{ item }">
				<span :class="itemEstornouTudo(item) ? 'text-decoration-line-through' : ''">{{
					item.unidadeDespesa
				}}</span>
			</template>
			<template #item.unidadeAquisicao="{ item }">
				<texto-tooltip
					:class="itemEstornouTudo(item) ? 'text-decoration-line-through' : ''"
					:texto="item.unidadeAquisicao"
					:tamanho-maximo="textoTamanhoMaximo.unidadeAquisicao"
				></texto-tooltip>
			</template>
			<template #item.fornecedor="{ item }">
				<texto-tooltip
					:class="itemEstornouTudo(item) ? 'text-decoration-line-through' : ''"
					:texto="item.fornecedor"
					:tamanho-maximo="textoTamanhoMaximo.fornecedor"
				></texto-tooltip>
			</template>
			<template #item.valorUnitario="{ item }">
				<span :class="itemEstornouTudo(item) ? 'text-decoration-line-through' : ''">
					{{ item.valorUnitario | azCurrency(numeroCasasDecimaisValores) }}
				</span>
			</template>
			<template #item.saldoDisponivelAdesao="{ item }">
				<span :class="itemEstornouTudo(item) ? 'text-decoration-line-through' : ''">
					{{ item.saldoDisponivelAdesao | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}
				</span>
			</template>
			<template #item.saldoDisponivelOrgao="{ item }">
				<span :class="itemEstornouTudo(item) ? 'text-decoration-line-through' : ''">
					{{ item.saldoDisponivelOrgao | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}
				</span>
			</template>
			<template #item.qtdUtilizada="{ item }">
				<span :class="itemEstornouTudo(item) ? 'text-decoration-line-through' : ''">
					{{ item.qtdUtilizada | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}
				</span>
			</template>
			<template #item.saldoLimiteAUtilizar="{ item }">
				<span :class="itemEstornouTudo(item) ? 'text-decoration-line-through' : ''">
					{{ item.saldoLimiteAUtilizar | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}
				</span>
			</template>
			<template #item.quantidadeSolicitada="{ item }">
				<div
					class="d-flex justify-space-evenly"
					v-if="numeroCasasDecimaisQtde !== null && numeroCasasDecimaisQtde !== undefined"
				>
					<az-money
						v-model="item._quantidadeSolicitada"
						:name="`Quantidade-${item.id}`"
						:precision="numeroCasasDecimaisQtde"
						prefix=""
						:class="['campo-quantidade', itemEstornouTudo(item) ? 'text-decoration-line-through' : '']"
						show-clear-button
						:disabled="!temPermissao"
						dense
						@input="atualizarValor(item)"
					></az-money>
				</div>
			</template>

			<template #item.acoes="{ item }">
				<div v-if="podeExibirMenuAcoes(item)">
					<itens-adesao-btn-acoes
						:item="item"
						@estornar="abrirModalEstorno(item, true)"
					></itens-adesao-btn-acoes>
				</div>
			</template>
		</v-data-table>

		<template-listagem-vazia
			:total-itens="totalItens"
			:textos="textosDoTemplateDaListagemVazia"
		></template-listagem-vazia>

		<paginacao-tabela
			v-if="totalItens > 0"
			:page.sync="paginacaoInterna.page"
			:rows-per-page.sync="paginacaoInterna.rowsPerPage"
			:totalPaginas="totalPaginas"
			:totalItens="totalItens"
			@resetar-page="resetarPage"
			@paginar="setPaginacao"
		></paginacao-tabela>

		<modal-exibir-justificativa
			titulo="Recusa do Item"
			:justificativa="justificativaRecusaItem"
			@fechar="fecharModalJustificativa"
			:exibir="exibirModalExibeJustificativa"
		></modal-exibir-justificativa>
	</div>
</template>
<script>
import tabelaMixin from '@/views/mixins/tabela'
import { TabelaColunaUtils } from '@/core/utils'
import TextoTooltip from '@/views/components/TextoTooltip.vue'
import TemplateListagemVazia from '@/views/components/TemplateListagemVazia.vue'
import PaginacaoTabela from '@/views/components/PaginacaoTabela.vue'
import mutationTypes from '@/core/constants/mutation-types'
import ModalExibirJustificativa from '@/views/pages/adesao/aderente/modal-exibir-justificativa/ModalExibirJustificativa.vue'
import { mapState } from 'vuex'
import permissoes from '@/core/constants/permissoes'
import ItensAdesaoBtnAcoes from '@/views/pages/adesao/aderente/itens/listagem/botoes-acoes-listagem/ItensAdesaoBtnAcoes.vue'
import IconeEstornadoParcialmente from '@/views/components/icones/IconeEstornadoParcialmente.vue'
import IconeEstornado from '@/views/components/icones/IconeEstornado.vue'
import tipos from '@/core/constants/tipos'
import adesaoAta from '@/views/mixins/adesaoAta'

export default {
	name: 'itens-adesao-listagem',
	components: {
		IconeEstornado,
		IconeEstornadoParcialmente,
		ItensAdesaoBtnAcoes,
		ModalExibirJustificativa,
		PaginacaoTabela,
		TemplateListagemVazia,
		TextoTooltip,
	},
	mixins: [tabelaMixin, adesaoAta],
	props: {
		itens: {
			type: Array,
			required: true,
		},
		hasAuthority: {
			type: Boolean,
		},
		permissaoVisualizarSaldo: {
			type: Boolean,
		},
	},

	data() {
		return {
			exibirModalExibeJustificativa: false,
			justificativaRecusaItem: '',
			paginacaoInterna: this.$store.state.adesao.paginacao,
			textosDoTemplateDaListagemVazia: {
				titulo: 'Nenhum item para adesão para adicionar por aqui',
			},
			textoTamanhoMaximo: {
				tipo: 25,
				codigo: 25,
				descricao: 25,
				marca: 25,
				unidadeAquisicao: 25,
				fornecedor: 25,
			},
		}
	},
	computed: {
		...mapState({
			numeroCasasDecimaisQtde: (state) => state.adesao.informacoesAdesao.numeroCasasDecimaisQtde,
			numeroCasasDecimaisValores: (state) => state.adesao.informacoesAdesao.numeroCasasDecimaisValores,
			isSelecionouTodosItensAdesao: (state) => state.adesao.itensAdesao.isSelecionouTodosItensAdesao,
		}),
		colunas() {
			return this.getColunasTabela()
		},
		temPermissao() {
			return this.hasAuthority
		},
		itensAdesaoSelecionados: {
			get() {
				return this.$store.state.adesao.itensAdesao.itensSelecionados
			},
			set(item) {
				this.$store.commit(mutationTypes.ADESAO.ITENS.SET_ITENS_SELECIONADOS, item)
			},
		},
	},
	watch: {
		paginacaoInterna: {
			async handler(paginacao) {
				await this.setPaginacao(paginacao)
			},
			deep: true,
		},
	},
	created() {
		this.limparCheckBox()
	},
	methods: {
		atualizarValor(item) {
			if (item._quantidadeSolicitada > 0) {
				this.$emit('salvar-item', item)
			} else {
				this.$emit('limpar-campo', item)
			}
		},
		getColunasTabela() {
			const colunas = []

			colunas.push(new TabelaColunaUtils('', 'icone', '1%'))
			colunas.push(new TabelaColunaUtils('Tipo', 'tipo', '8%'))
			colunas.push(new TabelaColunaUtils('Seq', 'sequencia', '4%'))
			colunas.push(
				new TabelaColunaUtils('Descrição', 'descricao', !this.permissaoVisualizarSaldo ? '20%' : '14%'),
			)
			colunas.push(new TabelaColunaUtils('Nat. Despesa', 'unidadeDespesa', '7%'))
			colunas.push(new TabelaColunaUtils('Unid. Aquis.', 'unidadeAquisicao', '5%'))
			colunas.push(new TabelaColunaUtils('Fornecedor', 'fornecedor', '14%'))
			colunas.push(new TabelaColunaUtils('Valor Unitário', 'valorUnitario', '8%'))

			if (!this.permissaoVisualizarSaldo) {
				colunas.push(new TabelaColunaUtils('Saldo disp. Órgão', 'saldoDisponivelOrgao', '8%'))
			} else {
				colunas.push(new TabelaColunaUtils('Qtde limite Utilização', 'saldoDisponivelAdesao', '6%'))
				colunas.push(new TabelaColunaUtils('Qtde Utilizada', 'qtdUtilizada', '6%'))
				colunas.push(new TabelaColunaUtils('Saldo limite a utilizar', 'saldoLimiteAUtilizar', '6%'))
				colunas.push(new TabelaColunaUtils('Saldo disp. Órgão', 'saldoDisponivelOrgao', '6%'))
			}

			colunas.push(new TabelaColunaUtils('Qtde. Adesão', 'quantidadeSolicitada', '14%'))
			colunas.push(new TabelaColunaUtils('Ações', 'acoes', '5%'))

			return colunas
		},
		resetarPage() {
			this.$emit('resetar-page')
		},
		async setPaginacao(paginacao) {
			this.$store.commit(mutationTypes.ADESAO.SET_PAGINACAO_LISTAGEM, paginacao)
		},
		fecharModalJustificativa() {
			this.exibirModalExibeJustificativa = false
		},
		itemEstornouTudo(item) {
			return item.tipoEstorno === tipos.TIPO_ESTORNO_ITEM_ADESAO.ESTORNO_COMPLETO.value
		},
		itemEstornouParcialmente(item) {
			return item.tipoEstorno === tipos.TIPO_ESTORNO_ITEM_ADESAO.ESTORNO_PARCIAL.value
		},
		onSelectAll(value) {
			if (value && !this.isSelecionouTodosItensAdesao) {
				this.$store.commit(mutationTypes.ADESAO.ITENS.SET_TODOS_ITENS_SELECIONADOS, true)
				this.itensAdesaoSelecionados = this.itens
			} else {
				this.limparCheckBox()
			}
		},
		limparCheckBox() {
			this.$store.commit(mutationTypes.ADESAO.ITENS.SET_TODOS_ITENS_SELECIONADOS, false)
			this.itensAdesaoSelecionados = []
		},
		podeExibirMenuAcoes(item) {
			return this.podeEstornar(item) || item.tipoEstorno
		},
		podeEstornar(item) {
			return (
				this.isPermissaoAutorizada(permissoes.ataAdesaoItemEstornar) &&
				this.verificarPermissao(permissoes.ataAdesaoItemEstornar) &&
				item.quantidadeSolicitada > 0 &&
				this.isConcluida
			)
		},
		podeExibirCheckbox() {
			return (
				this.isPermissaoAutorizada(permissoes.ataAdesaoItemEstornar) &&
				this.verificarPermissao(permissoes.ataAdesaoItemEstornar) &&
				this.isConcluida
			)
		},
		abrirModalEstorno(item, isEstornar) {
			this.$emit('abrir-modal-estorno', [item], isEstornar)
		},
	},
}
</script>
<style lang="stylus">
.campo-quantidade
	font-size 14px !important
	margin-top 15px !important

	.v-icon
		font-size 15px !important
</style>
